import { Divide } from "lucide-react";
import { useState } from "react";

import DescontoCupom from "./DescontoCupom";
import DivisaoAtiva from "./DivisaoAtiva";
import FormasPagamento from "./FormasPagamento";
import { CampoValor, LogPagamentos } from "./TotalAPagar";
import { Button } from "../../../components/ui/button";
import { brl } from "../lib/formato";

function Valor({ f }) {
  const { total, divisao, produtos } = f;
  let titulo = "Total a pagar";
  if (divisao.parte) titulo = `Parte ${divisao.parte.numero} de ${divisao.parte.total}`;
  else if (produtos.selecionadosQtd > 0) titulo = `${produtos.selecionadosQtd} produto(s)`;
  return (
    <div className="min-w-0">
      <p className={`text-xs ${divisao.parte ? "font-bold text-amber-600 dark:text-amber-400" : "text-muted-foreground"}`}>
        {titulo}
        {total.desconto > 0 && <span className="ml-1.5 line-through tabular-nums">{brl(total.subtotal)}</span>}
      </p>
      <div className="flex items-baseline gap-1">
        <span className="text-lg font-bold text-primary">R$</span>
        <CampoValor total={total} travado={!!divisao.parte} parte={divisao.parte} onEditarParte={divisao.onEditarParte} compacto />
      </div>
    </div>
  );
}

function Pago({ total, aberto, onAlternar }) {
  const gravado = Number(total.descontoGravado) || 0;
  if (!(total.pago > 0 || gravado > 0)) return null;
  return (
    <button type="button" onClick={onAlternar} className="text-right text-[11px] leading-tight shrink-0 tabular-nums">
      <span className="block font-semibold text-green-600 dark:text-green-400">Pago {brl(total.pago)}</span>
      {/* Desconto concedido em pagamento anterior: gravado, já fora do Falta (achado 503) */}
      {gravado > 0 && <span className="block font-semibold text-green-600 dark:text-green-400">Desconto já aplicado {brl(gravado)}</span>}
      <span className="block font-semibold text-orange-600 dark:text-orange-400">Falta {brl(total.restante)}</span>
      <span className="text-primary underline">{aberto ? "ocultar" : "ver"} pagamentos</span>
    </button>
  );
}

/**
 * Celular: o pagamento vira uma barra presa embaixo da tela (decisão do dono,
 * 24/09/2026) — os produtos rolam em cima e o valor, o DIVIDIR, o desconto,
 * as formas e o Confirmar ficam sempre à vista. No computador quem aparece é o
 * painel da direita (PainelPagamento).
 */
export default function BarraPagamentoMobile({ f, onAbrirDividir }) {
  const [verPagos, setVerPagos] = useState(false);
  const { total, divisao, desconto, pagamento, pmVisual } = f;
  return (
    <div className="md:hidden shrink-0 border-t bg-card shadow-[0_-8px_24px_rgba(0,0,0,0.25)] max-h-[72dvh] overflow-y-auto">
      <div className="px-3 pt-3 pb-2 space-y-2.5">
        <div className="flex items-end justify-between gap-3">
          <Valor f={f} />
          <Pago total={total} aberto={verPagos} onAlternar={() => setVerPagos((v) => !v)} />
        </div>
        {verPagos && <LogPagamentos log={total.log} pmVisual={pmVisual} onApagar={total.onApagar} />}
        {divisao.atual ? (
          <DivisaoAtiva divisao={divisao.atual} onCancelar={divisao.onCancelar} onEditarParte={divisao.onEditarParte} rotuloInteira={f.textos?.inteira} />
        ) : (
          <div className="flex items-start gap-2">
            <div className="flex-1 min-w-0"><DescontoCupom desconto={desconto} subtotal={total.subtotal} /></div>
            <Button
              type="button"
              variant="outline"
              onClick={onAbrirDividir}
              disabled={!(divisao.valorBase > 0)}
              className="h-[46px] px-3 shrink-0 font-bold border-amber-500/60 text-amber-600 dark:text-amber-400 hover:bg-amber-500/10"
            >
              <Divide className="w-4 h-4 mr-1" /> DIVIDIR
            </Button>
          </div>
        )}
        <FormasPagamento pagamento={pagamento} pmVisual={pmVisual} compacto />
      </div>
      <div className="sticky bottom-0 bg-card px-3 pb-3 pt-1">
        <Button className="w-full h-12 text-base font-bold" onClick={pagamento.confirmar} disabled={!pagamento.podeConfirmar}>
          {pagamento.rotuloBotao || (divisao.parte ? `Confirmar parte ${divisao.parte.numero} de ${divisao.parte.total}` : "Confirmar Pagamento")}
        </Button>
      </div>
    </div>
  );
}
